module.exports = __webpack_public_path__ + "static/img/tayih landis.541471a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/tayih landis.png?20181011
// module id = d2Qo
// module chunks = 1